<template>
  <Modal title="" :max-width="520" :header-border="false" body-overflow="auto" body-max-height="400px" :body-padding="false" @close="onClose">
    <template #header>
      <div class="cd__title-wrap">
        <span class="cd-source">
          <span class="cd-source__mark" style="background: #64748b; color: #fff;">
            <svg viewBox="0 0 16 16" fill="currentColor"><path d="M8 2a6 6 0 110 12A6 6 0 018 2zm-.75 3.5v5h1.5v-5h-1.5zm0-2v1.5h1.5V3.5h-1.5z"/></svg>
          </span>
          Agent
        </span>
        <div class="cd__name">{{ agentName || 'Agent Memory' }}</div>
      </div>
    </template>

    <div class="story-body">
      <div class="story-sentence">{{ sentence || '(no details)' }}</div>
    </div>

    <template #footer>
      <a v-if="runId" :href="`/agent-runs/${runId}`" class="cd-btn cd-btn--ghost" target="_blank" rel="noopener">View run</a>
      <button class="cd-btn cd-btn--ghost" @click="onClose">Close</button>
    </template>
  </Modal>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import Modal from '../../next/components/Modal.vue'

const props = defineProps<{
  story: Record<string, any>
  onClose: () => void
}>()

const agentName = computed(() => String(props.story?.data?.agent_name || '').trim())
const sentence = computed(() => String(props.story?.data?.sentence || '').trim())
const runId = computed(() => String(props.story?.run_id || '').trim() || null)
</script>

<style scoped>
.story-body {
  padding: var(--space-5);
}

.story-sentence {
  font-size: var(--fs-sm);
  line-height: var(--lh-loose);
  color: var(--color-text-primary);
  white-space: pre-wrap;
}
</style>
